import { AutogenModelCommentType, AutogenRowCommentType } from "./autogen/AutogenModelCommentType";

export class ModelCommentType extends AutogenModelCommentType<RowCommentType> {
    constructor() {
        super(RowCommentType);
    }
}

export class RowCommentType extends AutogenRowCommentType {
}